<script setup>
defineProps({
  modelValue: {
    required: true
  },
  currency: String,
  label: String,
  placeholder: String,
  required: Boolean,
  disabled: Boolean,
  autofocus: Boolean,
  pending: Boolean,
  pendingValue: String,
  rows: String,
  maxlength: Number
})
</script>

<template>
  <div class="flex flex-col gap-2 bg-white rounded border p-2 overflow-hidden">
    <label v-if="label" :for="label" class="flex gap-1 text-xs font-light opacity-75">
      <span>{{ label }}</span>
      <span v-if="!required" class="lowercase">({{ $t('labels.optional') }})</span>
    </label>
    <div class="flex items-center w-full">
      <div v-if="pending" class="cursor-wait disabled pointer-events-none opacity-50">
        {{ pendingValue }}
      </div>
      <textarea
        v-else
        :id="label"
        class="w-full font-normal"
        :value="modelValue"
        :required
        :placeholder
        :autofocus
        :rows
        :maxlength
        :class="{ 'pointer-events-none opacity-50': disabled }"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<style scoped>
textarea:-webkit-autofill {
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: #000 !important;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
